import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BRAND, FOOTER_LINKS } from '../lib/mock';
import { SP_FOOTER } from '../lib/mockStudent';
import { SCHOOL_FOOTER } from '../lib/mockSchool';
import { RESEARCHER_FOOTER } from '../lib/mockResearcher';
import { COACHING_FOOTER } from '../lib/mockCoaching';
import { PARTNERS_FOOTER } from '../lib/mockPartners';
import { EXPLORE_FOOTER } from '../lib/mockExplore';

function useProfile() {
  const loc = useLocation();
  if (loc.pathname.startsWith('/student-parent') || loc.pathname === '/access-request') return 'student-parent';
  if (loc.pathname.startsWith('/school')) return 'school';
  if (loc.pathname.startsWith('/researcher')) return 'researcher';
  if (loc.pathname.startsWith('/coaching')) return 'coaching';
  if (loc.pathname.startsWith('/partners') || loc.pathname === '/partnership-request') return 'partners';
  if (loc.pathname.startsWith('/explore')) return 'explore';
  return 'default';
}

export default function Footer() {
  const profile = useProfile();

  if (profile === 'student-parent') {
    return (
      <footer className="bg-navy text-white">
        <div className="mx-auto max-w-[1240px] px-6 py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
            <div>
              <div className="text-[15px] font-bold tracking-widest">GYAN DHARA</div>
              <p className="mt-3 max-w-xs text-[12.5px] leading-relaxed text-white/70">{SP_FOOTER.brandNote}</p>
              <div className="mt-4 text-[11.5px] font-bold tracking-widest text-cyan">STUDENT & PARENT EXPERIENCE</div>
            </div>
            {SP_FOOTER.cols.map(col => (
              <div key={col.title}>
                <div className="text-[13px] font-semibold text-white/90">{col.title}</div>
                <ul className="mt-3 space-y-2 text-[13px] text-white/70">
                  {col.items.map(l => (
                    <li key={l.label}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-10 border-t border-white/10 pt-6 text-[11.5px] text-white/50">Conceptualized, designed and developed by {BRAND.developedAt}.</div>
        </div>
      </footer>
    );
  }

  if (profile === 'partners') {
    return (
      <footer className="bg-navy text-white">
        <div className="mx-auto max-w-[1240px] px-6 py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
            <div>
              <div className="text-[15px] font-bold tracking-widest">GYAN DHARA</div>
              <p className="mt-3 max-w-xs text-[12.5px] leading-relaxed text-white/70">{PARTNERS_FOOTER.brandNote}</p>
              <div className="mt-4 text-[11.5px] font-bold tracking-widest text-cyan">PARTNERSHIPS</div>
            </div>
            {PARTNERS_FOOTER.cols.map(col => (
              <div key={col.title}>
                <div className="text-[13px] font-semibold text-white/90">{col.title}</div>
                <ul className="mt-3 space-y-2 text-[13px] text-white/70">
                  {col.items.map(l => (
                    <li key={l.label} data-testid={`partners-footer-link-${l.label.toLowerCase().replace(/\s+/g,'-')}`}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-10 border-t border-white/10 pt-6 text-[11.5px] text-white/50">© Gyan Dhara · Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati</div>
        </div>
      </footer>
    );
  }

  if (profile === 'coaching') {
    return (
      <footer className="bg-navy text-white">
        <div className="mx-auto max-w-[1240px] px-6 py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
            <div>
              <div className="text-[15px] font-bold tracking-widest">GYAN DHARA</div>
              <p className="mt-3 max-w-xs text-[12.5px] leading-relaxed text-white/70">{COACHING_FOOTER.brandNote}</p>
              <div className="mt-4 text-[11.5px] font-bold tracking-widest text-cyan">COACHING INSTITUTES</div>
            </div>
            {COACHING_FOOTER.cols.map(col => (
              <div key={col.title}>
                <div className="text-[13px] font-semibold text-white/90">{col.title}</div>
                <ul className="mt-3 space-y-2 text-[13px] text-white/70">
                  {col.items.map(l => (
                    <li key={l.label} data-testid={`coaching-footer-link-${l.label.toLowerCase().replace(/\s+/g,'-')}`}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-10 border-t border-white/10 pt-6 text-[11.5px] text-white/50">© Gyan Dhara · Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati</div>
        </div>
      </footer>
    );
  }

  if (profile === 'explore') {
    return (
      <footer className="bg-navy text-white">
        <div className="mx-auto max-w-[1240px] px-6 py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
            <div>
              <div className="text-[15px] font-bold tracking-widest">GYAN DHARA</div>
              <p className="mt-3 max-w-xs text-[12.5px] leading-relaxed text-white/70">{EXPLORE_FOOTER.brandNote}</p>
              <div className="mt-4 text-[11.5px] font-bold tracking-widest text-cyan">EXPLORE GYAN DHARA</div>
            </div>
            {EXPLORE_FOOTER.cols.map(col => (
              <div key={col.title}>
                <div className="text-[13px] font-semibold text-white/90">{col.title}</div>
                <ul className="mt-3 space-y-2 text-[13px] text-white/70">
                  {col.items.map(l => (
                    <li key={l.label} data-testid={`explore-footer-link-${l.label.toLowerCase().replace(/\s+/g,'-')}`}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-10 border-t border-white/10 pt-6 text-[11.5px] text-white/50">© Gyan Dhara · Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati</div>
        </div>
      </footer>
    );
  }

  if (profile === 'researcher') {
    return (
      <footer className="bg-navy text-white">
        <div className="mx-auto max-w-[1240px] px-6 py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
            <div>
              <div className="text-[15px] font-bold tracking-widest">GYAN DHARA</div>
              <p className="mt-3 max-w-xs text-[12.5px] leading-relaxed text-white/70">{RESEARCHER_FOOTER.brandNote}</p>
              <div className="mt-4 text-[11.5px] font-bold tracking-widest text-cyan">RESEARCH &amp; COLLABORATION</div>
            </div>
            {RESEARCHER_FOOTER.cols.map(col => (
              <div key={col.title}>
                <div className="text-[13px] font-semibold text-white/90">{col.title}</div>
                <ul className="mt-3 space-y-2 text-[13px] text-white/70">
                  {col.items.map(l => (
                    <li key={l.label} data-testid={`researcher-footer-link-${l.label.toLowerCase().replace(/\s+/g,'-')}`}>{l.to.startsWith('mailto:') ? <a href={l.to} className="hover:text-white transition-colors">{l.label}</a> : <Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link>}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-10 border-t border-white/10 pt-6 text-[11.5px] text-white/50">© Gyan Dhara · Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati</div>
        </div>
      </footer>
    );
  }

  if (profile === 'school') {
    return (
      <footer className="bg-navy text-white">
        <div className="mx-auto max-w-[1240px] px-6 py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
            <div>
              <div className="text-[15px] font-bold tracking-widest">GYAN DHARA</div>
              <p className="mt-3 max-w-xs text-[12.5px] leading-relaxed text-white/70">{SCHOOL_FOOTER.brandNote}</p>
              <div className="mt-4 text-[11.5px] font-bold tracking-widest text-cyan">SCHOOL DEPLOYMENT</div>
            </div>
            {SCHOOL_FOOTER.cols.map(col => (
              <div key={col.title}>
                <div className="text-[13px] font-semibold text-white/90">{col.title}</div>
                <ul className="mt-3 space-y-2 text-[13px] text-white/70">
                  {col.items.map(l => (
                    <li key={l.label} data-testid={`school-footer-link-${l.label.toLowerCase().replace(/\s+/g,'-')}`}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-10 border-t border-white/10 pt-6 text-[11.5px] text-white/50">© Gyan Dhara · Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati</div>
        </div>
      </footer>
    );
  }

  // default footer
  return (
    <footer className="bg-navy text-white">
      <div className="mx-auto max-w-[1240px] px-6 py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div>
            <div className="text-[15px] font-bold tracking-widest">GYAN DHARA</div>
            <p className="mt-3 max-w-xs text-[12.5px] leading-relaxed text-white/70">Conceptualized, designed and developed by {BRAND.developedAt}.</p>
          </div>
          <div>
            <div className="text-[13px] font-semibold text-white/90">Explore</div>
            <ul className="mt-3 space-y-2 text-[13px] text-white/70">{FOOTER_LINKS.explore.map(l => (<li key={l.label}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>))}</ul>
          </div>
          <div>
            <div className="text-[13px] font-semibold text-white/90">About</div>
            <ul className="mt-3 space-y-2 text-[13px] text-white/70">{FOOTER_LINKS.about.map(l => (<li key={l.label}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>))}</ul>
          </div>
          <div>
            <div className="text-[13px] font-semibold text-white/90">Contact</div>
            <ul className="mt-3 space-y-2 text-[13px] text-white/70">
              <li><a href={`mailto:${BRAND.contactEmail}`} className="hover:text-white transition-colors">{BRAND.contactEmail}</a></li>
              <li>Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati</li>
              <li>Assam, India</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
